import React, {Component} from 'react';
import {RichText} from 'prismic-reactjs';
import {Link} from 'react-router-dom';
import {routes, site} from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import DownArrow from "../parts/DownArrow";
import classNames from 'classnames';
import Loader from "../parts/Loader";
import {withStyles, withTheme} from '@material-ui/core/styles';
import {standardContainer} from "../styles/mixins";
import Container from "../parts/Container";
import Section from "../parts/Section";
import Typography from "../parts/Typography";
import Slider from 'react-slick';
import Testimonial from "../parts/Testimonial";
import "slick-carousel/slick/slick.css";
import CallToActionSection from "../sections/CallToActionSection";
import ChatScrollTrigger from "../parts/ChatScrollTrigger";


class HomePage extends Component {
  counter = null;
  slideInterval = 4000;
  initialDelay = 0;

  constructor(props) {
    super(props);
    this.worksReel = this.worksReel.bind(this);
    this.activateWorks = this.activateWorks.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.slideClick = this.slideClick.bind(this);
    this.startSlideTimer = this.startSlideTimer.bind(this);
    this.state = {
      showWorks: false,
      slideCounter: 0
    };

    const {theme} = props;

    this.sliderSettings = {
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
    };

  }

  startSlideTimer() {
    this.counter = setInterval(this.nextSlide, this.slideInterval); // Change slide
  }

  slideClick() {
    clearInterval(this.counter);
    this.nextSlide();
    this.startSlideTimer();
  }

  nextSlide() {
    this.setState({
      slideCounter: this.state.slideCounter + 1
    });
  }

  activateWorks() {
    this.setState({
      showWorks: true
    });
    document.getElementById('nav-bar').classList.add('alternate');
    setTimeout(this.startSlideTimer, this.initialDelay); // Transition in duration
  }

  componentDidMount() {
    window.analytics.page("Home");
  }

  componentWillUnmount() {
    document.getElementById('nav-bar').classList.remove('alternate');
    clearInterval(this.counter);
  }

  worksReel() {
    if (!this.props.works) return null;

    const works = this.props.works;

    return (
      <div className={classNames('works', {
        'show': this.state.showWorks
      })}>
        <div className={'overlay'}/>
        <img style={{display: 'none'}}
             onLoad={this.activateWorks}
             src={works[0].data.hero_image.url}/>
        <ul onClick={this.slideClick} className={'slides'}>
          {this.props.works.map((work, i) => {
            const data = work.data;

            const previousSlide = ((this.state.slideCounter - 1) % (works.length) === i);
            const currentSlide = (this.state.slideCounter % (works.length) === i);
            const nextSlide = ((this.state.slideCounter + 1) % (works.length) === i);

            return (
              <li key={work.uid}
                  className={classNames({
                    'previous': previousSlide,
                    'current': currentSlide,
                    'next': nextSlide,
                  })}
                  style={{backgroundImage: `url(${data.hero_image.url})`}}/>
            )
          })}
        </ul>
      </div>
    );
  }

  render() {
    const {classes} = this.props;

    window.prerenderReady = false;
    const data = (this.props.page && this.props.page.doc) ? this.props.page.doc.data : null;

    window.prerenderReady = !!(data);

    return (
      <div className='page-home'>
        {(data) ? (
          <React.Fragment>
            <Helmet>
              <title>{site.titlePrefix + data.meta_title}</title>
              {metaTitles(site.titlePrefix + 'Branding & Digital Consultancy')}
              {metaDescriptions('Gridhaus is a digital design consultancy. We help businesses do better through thoughtful strategy, clear insights, and effective digital experiences.')}
            </Helmet>
            <ChatScrollTrigger time={30}/>
            <section className={`hero ${classes.hero}`} id={'hero'}>
              <div className='animation-reel'>
                {this.worksReel()}
              </div>
              <div className={'container'}>
                <div className={"text"}>
                  <div className={classNames(
                    {'alternate': this.state.showWorks},
                    classes.message,
                  )}>
                    {RichText.render(data.hero_message)}</div>
                  <Link to={routes.work}>View our work</Link>
                </div>
              </div>
              <DownArrow scrollPastId={'hero'}/>
            </section>
            <div className={'content'}>
              <Section className={classes.interim}>
                <Container>
                  <div className={classes.interimContent} data-aos="grid-fade-up">
                    <div className={classes.interimMessage}>{data.interim_message}</div>
                    <div className={classes.interimBrief}>{RichText.render(data.interim_brief)}</div>
                  </div>
                </Container>
              </Section>
              <section className={'strategy explainer'}>
                <div className={'container'}>
                  <div className={'image'} data-aos="grid-fade-up">
                    <img src={data.strategy_image.url} alt={data.strategy_image.alt}/>
                  </div>
                  <div className="text" data-aos="grid-fade-up">
                    <h2 className={'message'}>{data.strategy_message}</h2>
                    <div className={'brief'}>{RichText.render(data.strategy_brief)}</div>
                    <Link to={routes.services}>See what we do</Link>
                  </div>
                </div>
              </section>
              <section className={'ethos explainer'}>
                <div className={'container'}>
                  <div className={'image'} data-aos="grid-fade-up">
                    <img src={data.ethos_image.url} alt={data.ethos_image.alt}/>
                  </div>
                  <div className="text" data-aos="grid-fade-up">
                    <h2 className={'message'}>{data.ethos_message}</h2>
                    <div className={'brief'}>{RichText.render(data.ethos_brief)}</div>
                    <Link to={routes.services}>Learn how we work</Link>
                  </div>
                </div>
              </section>
              <section className={'team explainer'}>
                <div className={'container'}>
                  <div className={'image'} data-aos="grid-fade-up">
                    <img src={data.team_image.url} alt={data.team_image.alt}/>
                  </div>
                  <div className="text" data-aos="grid-fade-up">
                    <h2 className={'message'}>{data.team_message}</h2>
                    <div className={'brief'}>{RichText.render(data.team_brief)}</div>
                    <Link to={routes.team}>Meet the team</Link>
                  </div>
                </div>
              </section>
              <Section small side={false} className={classes.testimonialSection}>
                <Container>
                  <Typography variant={'h2'} className={classes.testimonialTitle}>What clients are saying</Typography>
                </Container>
                <Slider {...this.sliderSettings} className={classes.testimonialSlider}>
                  {data.testimonials.map((testimonial, index) => (
                    <div className={classes.testimonialWrapper} key={index}>
                      <Testimonial
                        name={testimonial.name}
                        title={testimonial.title}
                        brief={RichText.render(testimonial.brief)}>
                      </Testimonial>
                    </div>
                  ))}
                </Slider>
              </Section>
              <Section className={classes.clientsSection}>
                <Container>
                  <Typography variant={'h2'} className={classes.clientsTitle}>Some of our amazing clients</Typography>
                  <ul className={classes.clients}>
                    {data.clients.map(client => (
                      <li className={classes.client} key={client.name}>
                        <img alt={client.name} className={classes.logo} src={client.logo.url}/>
                      </li>
                    ))}
                  </ul>
                </Container>
              </Section>
              <CallToActionSection/>
            </div>
          </React.Fragment>
        ) : <Loader loaded={false}/>}
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    ...standardContainer(theme),
  },
  interim: {
    background: theme.palette.secondary.dark,
    color: theme.palette.secondary.main,
  },
  interimContent: {
    textAlign: 'center',
  },
  interimMessage: {
    color: theme.palette.primary.main,
    ...theme.typography.hg54r(theme),
    marginBottom: theme.spacing.unit * 2,
  },
  interimBrief: {
    color: theme.palette.secondary.main,
    maxWidth: '30em',
    margin: '0 auto',
    ...theme.typography.hg36r(theme),
  },
  testimonialSection: {
    background: theme.palette.secondary.dark,
  },
  testimonialTitle: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    marginBottom: theme.spacing.unit * 4,
  },
  testimonialSlider: {
    '& .slick-track': {
      display: 'flex',
    },
    '& .slick-slide': {
      opacity: 0.75,
      transition: 'opacity 1s ease-out',
    },
    '& .slick-slide.slick-center': {
      opacity: 1,
    },
  },
  testimonialWrapper: {
    paddingLeft: theme.spacing.unit * 0.5,
    paddingRight: theme.spacing.unit * 0.5,
    [theme.breakpoints.up(400)]: {
      paddingLeft: theme.spacing.unit * 1,
      paddingRight: theme.spacing.unit * 1,
    },
    [theme.breakpoints.up(1280)]: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
    },
    display: 'flex',
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
  },
  hero: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'flex-end',
    }
  },
  message: {
    '& p': {
      ...theme.typography.hg54b(theme),
      marginBottom: theme.spacing.unit * 4,
      color: theme.palette.secondary.dark,
      maxWidth: '20em',
      '& strong': {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
      }
    },
    '&.alternate p': {
      color: theme.palette.secondary.main,
    },
  },
  clientsSection: {
    background: '#F7F7F7',
  },
  clientsTitle: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    marginBottom: theme.spacing.unit * 4,
  },
  clients: {
    textAlign: 'center',
    [theme.breakpoints.up(768)]: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: -30,
      justifyContent: 'center',
    }
  },
  client: {
    padding: 30,
  },
  logo: {
    height: 40,
    width: 'auto',
    maxWidth: '100%',
    display: 'inline-block',
  },
});

export default pageWithPrismic(withStyles(styles)(withTheme()(HomePage)), 'home_page',
  (state) => {
    return {works: state.works.items};
  });



// WEBPACK FOOTER //
// ./src/pages/HomePage.js